<template>
  <div>
    <div class="user-tree">
      <div class="tree_wrap">
        <el-tree
          ref="tree"
          :data="organizationData"
          :props="defaultProps"
          :load="loadNode"
          node-key="code"
          :current-node-key="activeCode"
          :highlight-current="true"
          :default-expand-all="true"
          accordion
          empty-text=""
          @node-click="treeNodeClick"
          :check-strictly="true"
          @node-expand="treeNodeClick"
          @node-collapse="treeNodeClick"
        >
        </el-tree>
      </div>
      <div class="user_wrap">
        <TreeList
          :treeData="organizationData"
          :activeCode="activeCode"
          ref="treeList"
        ></TreeList>
      </div>
    </div>
  </div>
</template>
<script>
import ZJApp from "../../../../../app";
import { listUser } from "@/api/system/permission/user";
import TreeList from "./TreeList";
import { deptTreeData } from "@/api/system/permission/dept";
export default {
  name: "ZjUserTabControl",
  controller: "UI",
  action: "UserTabControl",
  components: {
    TreeList,
  },
  props: {
    editable: { type: Boolean, default: false },
  },
  data() {
    return {
      ruleForm: {},
      editableTabs: [],
      editableTabsValue: "",
      orgOptions: [],
      OgrVal: "",
      organizationData: [],
      defaultProps: {
        children: "children",
        label: "label",
        id: "id",
      },
      activeCode: "",
    };
  },
  created: function () {
    this.getTreeselect();
  },
  methods: {
    // 查询部门下拉树结构
    getTreeselect() {
      deptTreeData().then((response) => {
        this.organizationData = response.data;
        this.activeCode = response.data[0].id;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.activeCode); // 默认选中节点第一个
        });
      });
    },

    loadNode(node, resolve) {
      return resolve(this.organizationData);
    },
    treeNodeClick(node) {
      this.activeCode = node.id;
      this.$refs.tree.setCurrentKey(this.activeCode);
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ {
  /* 改变被点击节点背景颜色，字体颜色 */
  .user-tree {
    display: flex;
    .el-tree-node > .el-tree-node__content {
      // margin-right: 20px;
      // padding-right: 20px;
      font-size: 1.2rem;
      font-weight: 500;
      color: #fff;
    }
    .el-tree-node:focus > .el-tree-node__content {
      background-color: unset !important;
      color: #298beb !important;
    }
    // .el-tree-node:focus > .el-tree-node__content>.el-tree-node__expand-icon {
    //   color: #298beb !important;
    // }
    //  .el-tree-node:focus > .el-tree-node__content>.is-leaf {
    //   color: transparent !important;
    // }
    /*节点失焦时的背景颜色*/
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      background-color: unset !important;
      color: #298beb !important;
    }
  }
  .tree_wrap {
    width: 20%;
    height: 31rem;
    overflow-y: scroll;
    overflow-x: auto;
  }
  .user_wrap {
    width: 80%;
    height: 31rem;
    overflow-y: auto;
    padding-left: 2rem;
  }
}
</style>
